import { useContext } from "react";

import { CreateEntityResponse } from "../../../common/api/common/CreateEntityResponse";
import { AppConfigContext } from "../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../core/data-access/useAuthorizedFetch";
import { CreateIntegratorRequest } from "./CreateIntegratorRequest";
import { DeleteIntegratorRequest } from "./DeleteIntegratorRequest";
import { GetIntegratorListResponse } from "./GetIntegratorListResponse";
import { GetIntegratorsLookupResponse } from "./GetIntegratorsLookupResponse";
import { ValidateIntegratorRequest } from "./ValidateIntegratorRequest";
import { ValidateIntegratorResponse } from "./ValidateIntegratorResponse";

export const useAdminIntegratorApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet, httpPost, httpDelete } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/integrators`;

    const getIntegratorList = async (): Promise<GetIntegratorListResponse> => {
        return httpGet<GetIntegratorListResponse>(`${baseUrl}/list`);
    };

    const getIntegratorsLookup = async (): Promise<GetIntegratorsLookupResponse> => {
        return httpGet<GetIntegratorsLookupResponse>(`${baseUrl}/get-lookup`);
    };

    const createIntegrator = async (request: CreateIntegratorRequest): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/create`, request);
    };

    const deleteIntegrator = async (request: DeleteIntegratorRequest): Promise<void> => {
        return httpDelete(`${baseUrl}/delete`, request);
    };

    const validateIntegratorDelete = async (
        request: ValidateIntegratorRequest
    ): Promise<ValidateIntegratorResponse> => {
        return httpGet(`${baseUrl}/validate-delete`, request);
    };

    return {
        getIntegratorList,
        getIntegratorsLookup,
        createIntegrator,
        deleteIntegrator,
        validateIntegratorDelete
    };
};
